.editorContainer {
  display: flex;
  flex: 1;
  position: relative;
  flex-direction: column;
}

.plateContent {
  display: flex;
  outline: none;
  flex-direction: column;
  flex: 1 1 auto;
  cursor: auto;
  position: relative;
}

.plateContent--gutter {
  padding: 0 0 0 24px;
}

.editorContainer--gutter {
  padding: 0 32px;
}

@media (max-width: 599.95px) {
  .plateContent--gutter {
    padding: 0 0 0 16px;
  }

  .editorContainer--gutter {
    padding: 0 4px;
  }
}
